<template>
  <div class="withdraw">
    <navbar>
      <template #left>
        <!-- <span class="material-icons">chevron_left</span> -->
        <svg t="1748487155504" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="21829" width=".6rem" height=".6rem">
          <path
            d="M637.5424 231.2192c22.8352 22.3232 24.6272 53.4016 0 80.6912l-191.8464 200.0896 191.8464 200.0896c24.6272 27.2896 22.8352 58.4192 0 80.5888-22.784 22.3232-61.2864 20.8896-82.688 0-21.4016-20.7872-230.5024-240.384-230.5024-240.384-11.4176-11.1104-17.152-25.7024-17.152-40.2944s5.7344-29.184 17.152-40.3968c0 0 209.1008-219.4944 230.5024-240.384s59.904-22.3232 82.688 0z"
            fill="#ffffff" p-id="21830"></path>
        </svg>
      </template>
      <template #title>
        <span style="color: #fff;font-size: .4267rem;">
          {{ $t('user.t10') }}
        </span>
      </template>
      <template #right>
        <!-- <span class="material-icons" @click="$router.push('/serve')">support_agent</span> -->
        <svg @click="$router.push('/serve')" t="1748486049022" class="icon" viewBox="0 0 1046 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="11906" width=".6rem" height=".6rem">
          <path
            d="M907.377778 521.398044c0-234.245689-181.771378-393.398044-384-393.398044-200.112356 0-384 155.739022-384 395.946667A83.968 83.968 0 0 0 96.711111 597.333333V682.666667A85.583644 85.583644 0 0 0 182.044444 768h42.666667V507.721956c0-165.114311 133.552356-298.666667 298.666667-298.666667s298.666667 133.575111 298.666666 298.689422v302.921956h-341.333333v85.333333h341.333333a85.583644 85.583644 0 0 0 85.333334-85.333333v-52.064711c25.167644-13.198222 42.666667-39.253333 42.666666-69.973334V590.506667c0-29.878044-17.499022-55.887644-42.666666-69.108623z"
            p-id="11907" fill="#fff"></path>
          <path
            d="M395.377778 597.333333a42.666667 42.666667 0 1 0 0-85.333333 42.666667 42.666667 0 0 0 0 85.333333zM651.377778 597.333333a42.666667 42.666667 0 1 0 0-85.333333 42.666667 42.666667 0 0 0 0 85.333333z"
            p-id="11908" fill="#fff"></path>
          <path
            d="M779.377778 470.607644c-20.48-121.605689-126.293333-214.607644-253.860978-214.607644-129.274311 0-268.379022 107.087644-257.297067 275.205689 105.403733-43.099022 184.775111-136.965689 207.371378-251.312356 55.887644 112.207644 170.666667 189.44 303.786667 190.714311z"
            p-id="11909" fill="#fff"></path>
        </svg>
      </template>
    </navbar>
    <div class="content">
      <div class="hint">
        {{ $t('user.t27') }}
      </div>
      <input type="text" class="ipts" readonly :placeholder="$t('user.t90')"
        style="font-weight: 700;font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;">
      <input type="text" class="ipts" v-model="bankInfo.bankname" :placeholder="$t('user.t28')">
      <input type="text" class="ipts" v-model="bankInfo.username" :placeholder="$t('user.t80')">
      <input type="text" class="ipts" v-model="bankInfo.id_number" :placeholder="$t('user.t65')">
      <input type="text" class="ipts" v-model="bankInfo.tel" :placeholder="$t('user.t31')">
      <input type="text" class="ipts" v-model="bankInfo.bank_email" :placeholder="$t('user.t86')">
      <input type="password" class="ipts" v-model="bankInfo.paypassword" :placeholder="$t('user.t23')">
      <div class="btn" @click="setBindBank">
        {{ $t('user.t32') }}
      </div>
      <div class="mute">
        {{ $t('user.t66') }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      radio: '0',
      actions: [],
      userInfo: {},
      // bank_code: '',
      bankInfo: {
        // bank_code: '',
        bankname: '',
        username: '',
        id_number: '',
        bank_email: '',
        tel: '',
      }
    }
  },
  created() {
    this.getBindBank();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },

  methods: {
    handleSelect(item) {
      // this.bankInfo.bank_code = item.name
    },
    getBindBank() {
      // if (this.bankInfo.bank_name) {
      //   this.$toast(this.$t('user.t77'))
      //   return
      // }
      // if (this.bankInfo.username) {
      //   this.$toast(this.$t('user.t80'))
      //   return
      // }
      // if (this.bankInfo.id_number) {
      //   this.$toast(this.$t('user.t81'))
      //   return
      // }
      // if (this.bankInfo.tel) {
      //   this.$toast(this.$t('user.t81'))
      //   return
      // }
      // if (this.bankInfo.bank_email) {
      //   this.$toast(this.$t('user.t87'))
      //   return
      // }
      // if (this.bankInfo.paypassword) {
      //   this.$toast(this.$t('user.t23'))
      //   return
      // }
      this.$http.getBindBank().then(res => {
        // this.bank_code = Object.values(res.data?.bank_list)[0]
        // this.bankInfo.bank_code = res.data.info ? res.data.info?.bank_code : Object.values(res.data?.bank_list)[0]
        this.bankInfo.bankname = res.data.info?.bankname
        this.bankInfo.username = res.data.info?.username
        this.bankInfo.id_number = res.data.info?.cardnum
        this.bankInfo.bank_email = res.data.info?.bank_email
        this.bankInfo.tel = res.data.info?.tel
      })
    },
    setBindBank() {
      // if (!this.bankInfo.bank_code) {
      //   this.$toast(this.$t('user.t89'))
      //   return
      // }
      if (!this.bankInfo.bankname) {
        this.$toast(this.$t('user.t77'))
        return
      }
      if (!this.bankInfo.username) {
        this.$toast(this.$t('user.t80'))
        return
      }
      if (!this.bankInfo.id_number) {
        this.$toast(this.$t('user.t78'))
        return
      }
      if (!this.bankInfo.tel) {
        this.$toast(this.$t('user.t81'))
        return
      }
      if (!this.bankInfo.bank_email) {
        this.$toast(this.$t('user.t87'))
        return
      }
      if (!this.bankInfo.paypassword) {
        this.$toast(this.$t('user.t23'))
        return
      }
      // if (!this.userInfo.pwd2) {
      //   this.$toast.fail(this.$t('user.t50'));
      //   return;
      // }

      this.$http.setBindBank(this.bankInfo).then(res => {
        if (res.code == 1) {
          this.$toast(res.info);
        } else {
          this.bankInfo = {}
          this.$toast(res.info);
          this.$router.push('/user');
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.withdraw {
  .material-icons {}

  span {}

  .content {
    margin-top: .64rem;
    padding: 0 .4rem;

    .hint {
      margin-top: .8rem;
      margin-bottom: .4rem;
      color: #fff;
      font-weight: bold;
    }

    .label {
      color: #fff;
      font-size: .32rem;
      margin-left: .4rem;
    }

    .ipts {
      margin-top: .2667rem;
      margin-bottom: .8rem;
      display: block;
      width: 100%;
      height: 1rem;
      background-color: #121212;
      border-radius: .1333rem;
      padding: .2133rem .4267rem;
      color: #fff;
      font-size: .3733rem;
      box-sizing: border-box;
    }

    .btn {
      color: #fff;
      background-color: #121212;
      margin-top: .64rem;
      padding: .3467rem 0;
      border-radius: .8rem;
      text-align: center;
    }

    .mute {
      margin-top: .2667rem;
      font-size: .32rem;
      color: #fff;
    }
  }

  ::v-deep {
    .van-radio {
      margin-bottom: .2133rem;
    }

    .van-radio__label {
      font-size: .32rem;
    }
  }
}
</style>
